import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions'
import mutations from './mutations'
import rights from './modules/rights'

Vue.use(Vuex);

export default new Vuex.Store({
    actions,
    mutations,
    modules: {
        rights
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js